import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyQuote from "./StickyQuote";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyQuote />
    </div>
  );
}
